module.exports = __webpack_public_path__ + "img/mobile-photography-secondary.44a64747.png";